import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCampaignsWithOOCFrames } from 'modules/api/directSalesOOC';
import { cancelFunctions } from 'utils/cancelFunctions';
import { setCampaignsWithOOCFrames } from 'store/pages/directSalesOOC/reducer';
import { getMarketId } from 'store/publisher/selectors';

export const useOOCReport = (): void => {
  const dispatch = useDispatch();

  const marketId = useSelector(getMarketId);

  useEffect(() => {
    const fetchCampaignsWithOOCFrames = async (): Promise<void> => {
      try {
        const response = await getCampaignsWithOOCFrames(marketId, cancelFunctions);

        dispatch(setCampaignsWithOOCFrames(response.campaignDetails));
      } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Failed to fetch OOC report:', error);
      }
    };

    fetchCampaignsWithOOCFrames();

    return () => {
      dispatch(setCampaignsWithOOCFrames([]));
    };
  }, [marketId]);
};
